import { Component, Signal } from '@angular/core';
import { OpeningHoursComponent } from '../opening-hours/opening-hours.component';
import { RouterModule } from '@angular/router';
import { ScrollService } from '../../../services/scroll.service';
import { WebsiteStateService } from '../../../state-management/services/website-state.service';
import { BusinessConfiguration, ContactData } from '../../../state-management/model/interfaces/state.model';
import { ConsentManagementService } from '../../../services/consent-management.service';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
    selector: 'app-footer',
    standalone: true,
    imports: [
        OpeningHoursComponent,
        RouterModule
    ],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})

export class FooterComponent {
  
  public configuration: Signal<BusinessConfiguration> = this.websiteState.configuration
  
  constructor(
    private websiteState: WebsiteStateService,
    private consentManagementService: ConsentManagementService,
    private analyticsService: AnalyticsService,
    public scrollService: ScrollService, 
  ) {
    // this.contactData = this.websiteState.configuration().contactData;
  }

  sendEmail(): void {
    if (this.configuration().contactData.email) window.location.href = `mailto:${this.configuration().contactData.email}`;
    else window.location.href = `mailto:${'du@dein-unternehmen.de'}`;
  }

  sendTrackingEvent(): void {
    this.analyticsService.trackEvent('footer', { event_category: 'click', event_label: 'footer' });
  }

  openCookieConsent(): void {
    this.consentManagementService.showPreferencesModal();
  }
}